module.exports = __webpack_public_path__ + "static/media/maplayer_2_4_1_3.12164812.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/04/assets/maplayer_2_4_1_3.svg
// module id = 478
// module chunks = 0